import React, { FC, SVGProps } from 'react';

/** Ceiling-mount PIR motion sensor — concentric rings */
const MotionSensor: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" {...props}>
    <circle cx="12" cy="12" r="10" strokeWidth="1.5" />
    <circle cx="12" cy="12" r="6" strokeWidth="1.5" />
    <circle cx="12" cy="12" r="2.5" fill="currentColor" stroke="none" />
  </svg>
);

export default MotionSensor;
